import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const Caret = () => _jsx("span", { className: 'caret' });
export default Caret;
